import { ArrowLeft } from 'lucide-react';

import type { TrackedClickableElementName } from '@savvy/deprecated-shared/tracking/tracked-clickable-element-name';

import TrackedButton from '../tracked/tracked-button';

export default function ItemDialogBackButton({
  trackedElementName,
  onClick,
}: {
  readonly trackedElementName: TrackedClickableElementName;
  readonly onClick: () => void;
}) {
  return (
    <TrackedButton
      elementName={trackedElementName}
      aria-label="Go back"
      onClick={onClick}
      className="absolute left-6 top-6"
      icon={<ArrowLeft />}
    >
      Back
    </TrackedButton>
  );
}
